import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {AddToCartSliceState, CartItem} from './InitialStatePropsModel'

const initialState: AddToCartSliceState = {
    cartItemCount: 0,
    cart: [], // Load from localStorage or default to 'light'
    subTotalPrice: 0,
    totalTax:0,
    subTotal:0,
    totalValue:0,
    totalDiscount:0,
    isCustomLoading:true,
    buyNowItem:null
};

const AddToCartSlice = createSlice({
  name: 'AddToCartSlice',
  initialState,
  reducers: {
    addToCart: (state, action:PayloadAction<CartItem[]>) => {
      state.cart = action.payload;
    },
    setCartItemCount: (state, action:PayloadAction<number>) => {
        state.cartItemCount = action.payload;
    },
    setTotalPrice: (state, action:PayloadAction<number>) => {
        state.subTotalPrice = action.payload;
    },
    setIsCustomLoading:(state, action:PayloadAction<boolean>) => {
      state.isCustomLoading = action.payload ? true:false;
    },
    setSubTotal:(state, action:PayloadAction<number>) => {
      state.subTotal = action.payload;
    },
    setTotalTax:(state, action:PayloadAction<number>) => {
      state.totalTax = action.payload;
    },
    setTotalValue:(state, action:PayloadAction<number>) => {
      state.totalValue = action.payload;
    },
    setSubTotalPrice:(state, action:PayloadAction<number>) => {
      state.subTotalPrice = action.payload;
    },
    setBuyNowItem:(state, action:PayloadAction<CartItem | null>) => {
      state.buyNowItem = action.payload;
    },
    setTotalDiscount:(state, action:PayloadAction<number>) => {
      state.totalDiscount = action.payload;
    },
  },
});


export const { addToCart, setCartItemCount, setTotalPrice, setIsCustomLoading, setBuyNowItem, setTotalDiscount } = AddToCartSlice.actions;

export default AddToCartSlice;
